import { useQuery } from "@tanstack/react-query";
import { api } from "../client";
import type { PublicSettings } from "../types";

export function usePublicSettings() {
  return useQuery({
    queryKey: ["settings", "public"],
    queryFn: () => api.get<PublicSettings>("/api/settings/public"),
    staleTime: 5 * 60_000,
  });
}
